import { render, staticRenderFns } from "./set-transceiver-deployment-mode.vue?vue&type=template&id=230a1554&"
import script from "./set-transceiver-deployment-mode.vue?vue&type=script&lang=ts&"
export * from "./set-transceiver-deployment-mode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports